/*
  Sincroniza la variante elegida con la imagen, el formulario y la URL.

  Por que existe: en este tema, al pulsar un boton de variante no cambiaba
  absolutamente nada (ni imagen, ni precio, ni stock, ni URL). La cadena de Dawn
  (evento -> publish -> subscribe -> construir URL -> fetch -> parsear ->
  fusionar galeria -> activar media) no llega a arrancar, porque su JavaScript
  propio venia en el bundle que el proveedor servia bajo licencia.

  Esto no intenta reparar esa cadena de 8 pasos: la sustituye por una de 3
  (leer seleccion -> resolver variante -> aplicar), que no depende de ninguno de
  sus eslabones. Si algun dia la cadena original vuelve a funcionar, esto no
  estorba: ambos dejarian la misma variante activa.

  Ademas del cambio de imagen corrige un fallo mas grave que estaba pasando
  desapercibido: como el <input name="id"> tampoco se actualizaba, comprar
  "Hvidguld" anadia "Guld" al carrito.
*/
(function () {
  function readVariants(root) {
    var node = root.querySelector('script[data-all-variants]');
    if (!node) {
      console.warn('variant-image-sync: falta el catalogo de variantes en <variant-selects>.');
      return [];
    }
    try {
      var data = JSON.parse(node.textContent);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      console.warn('variant-image-sync: el catalogo de variantes no es JSON valido.', e);
      return [];
    }
  }

  /*
    Devuelve los valores elegidos en orden de opcion. Se recorre cada grupo
    .product-form__input y se toma su radio marcado o su <select>, lo que haya:
    asi valen los tres tipos de selector (pildora, muestra y desplegable) sin
    ramificar por tipo. El orden del DOM coincide con el de product.options.
  */
  function selectedValues(root) {
    var values = [];
    var groups = root.querySelectorAll('.product-form__input');

    Array.prototype.forEach.call(groups, function (group) {
      var radio = group.querySelector('input[type="radio"]:checked');
      if (radio) {
        values.push(radio.value);
        return;
      }
      var select = group.querySelector('select');
      if (select) values.push(select.value);
    });

    return values;
  }

  function resolveVariant(variants, values) {
    if (!values.length) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var k = 0; k < values.length; k++) {
        if (v['option' + (k + 1)] !== values[k]) {
          ok = false;
          break;
        }
      }
      if (ok) return v;
    }
    return null;
  }

  /*
    Localiza la diapositiva de la galeria. Primero por id de media; si el JSON
    de variantes no trae featured_media (no todas las tiendas lo incluyen), se
    compara el nombre del archivo de imagen, porque las URLs de Shopify llevan
    parametros de tamano distintos segun el contexto.
  */
  function findSlide(gallery, variant, sectionId) {
    var mediaId = variant.featured_media && variant.featured_media.id;
    if (mediaId) {
      var byId = gallery.querySelector('[data-media-id="' + sectionId + '-' + mediaId + '"]');
      if (byId) return byId;
    }

    var image = variant.featured_image || (variant.featured_media && variant.featured_media.preview_image);
    if (!image || !image.src) return null;

    var file = String(image.src).split('?')[0].split('/').pop();
    var slides = gallery.querySelectorAll('[data-media-id]');
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      if (!img) continue;
      if ((img.getAttribute('src') || '').split('?')[0].split('/').pop() === file) return slides[i];
    }
    return null;
  }

  function updateImage(variant, sectionId) {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var slide = findSlide(gallery, variant, sectionId);
    if (!slide) {
      console.warn('variant-image-sync: la imagen de esta variante no esta en la galeria.', {
        variante: variant.id,
        featured_media: variant.featured_media,
        featured_image: variant.featured_image
      });
      return;
    }

    // setActiveMedia hace activeMedia.classList.add(...) sin comprobar null,
    // asi que solo se llama despues de confirmar que el <li> existe.
    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(slide.dataset.mediaId, true);
      return;
    }

    var list = slide.parentElement;
    Array.prototype.forEach.call(list.querySelectorAll('[data-media-id]'), function (li) {
      li.classList.remove('is-active');
    });
    slide.classList.add('is-active');
    list.prepend(slide);
  }

  // Sin esto se anade al carrito la variante equivocada.
  function updateFormVariant(variant, sectionId) {
    var form = document.getElementById('product-form-' + sectionId);
    if (!form) form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var input = form.querySelector('input[name="id"]');
    if (input) input.value = variant.id;
  }

  function updateUrl(variant) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {
      /* URL no soportada: no es critico, se ignora. */
    }
  }

  function onChange(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var root = target.closest('variant-selects');
    if (!root) return;

    var variants = readVariants(root);
    if (!variants.length) return;

    var values = selectedValues(root);
    var variant = resolveVariant(variants, values);

    if (!variant) {
      console.warn('variant-image-sync: ninguna variante coincide con la seleccion.', {
        elegido: values,
        ejemplo_de_variante: variants[0]
      });
      return;
    }

    var sectionId = root.dataset.section || '';
    updateFormVariant(variant, sectionId);
    updateImage(variant, sectionId);
    updateUrl(variant);
  }

  // Delegado en document: sobrevive a los reemplazos de DOM que hace Dawn
  // cuando re-renderiza el bloque de producto.
  document.addEventListener('change', onChange);

  // Se expone por si otro componente necesita la misma resolucion de imagen.
  window.SilkifyVariantMedia = { findSlide: findSlide, resolveVariant: resolveVariant };
})();
